import { useQuery } from "@tanstack/react-query";
import { fetchUnidades } from "@/integrations/generatorApi/client";

export function useUnidades() {
  return useQuery({
    queryKey: ["unidades"],
    queryFn: fetchUnidades,
    staleTime: 1000 * 60 * 5, // 5 minutos
  });
}
